// extracted by css-extract-rspack-plugin
export default {"label":"LLMReasoningRow_label__ISkpC","badgeWrapper":"LLMReasoningRow_badgeWrapper__36mfJ"};